import { render, staticRenderFns } from "./ForgotPasswordReset.vue?vue&type=template&id=7e605a6f&scoped=true&"
import script from "./ForgotPasswordReset.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordReset.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordReset.vue?vue&type=style&index=0&id=7e605a6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e605a6f",
  null
  
)

component.options.__file = "www/vues/login/ForgotPasswordReset.vue"
export default component.exports